export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7152.cdd3c945.jpg";